import React, { useEffect, useRef, useState } from "react";
import grapesjs from "grapesjs";
import "grapesjs/dist/css/grapes.min.css";
import "./emailEditor.css";
import presetNewsletter from "grapesjs-preset-newsletter";
import Freez from '../../../Components/Loader/Loader'
import DefaultLayout from '../../../Components/DefaultLayout';
import Backdrop from '@mui/material/Backdrop';
import swal from "sweetalert";
import AddIcon from "@mui/icons-material/Add";
import { fetchData, postFormData } from "../../../redux/apiSlice";
import { useDispatch } from "react-redux";
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from "@mui/icons-material/Delete";
import Visibility from "@mui/icons-material/Visibility";
import { useLocation, useNavigate } from "react-router-dom";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { LocalizationProvider, DatePicker, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import * as Yup from 'yup';
import moment from 'moment-timezone';
import { Formik, Form } from 'formik';
import { Box, Typography, IconButton, Button, TextField, InputAdornment, Dialog, DialogTitle, DialogActions, DialogContent, Select, MenuItem, CircularProgress, FormControlLabel, Autocomplete, Chip, RadioGroup, Radio } from "@mui/material";

const EmailEditor = () => {
    const [freez, setFreez] = useState(false);
    const editorRef = useRef(null);
    const editorInstance = useRef(null);
    const dispatch = useDispatch();
    const location = useLocation()
    const navigate = useNavigate();
    const selectedRows = location.state?.selectedRows || [];
    const uploadedFile = location.state?.uploadedFile || null;
    const selectedReport = location.state?.selectedReport || null;
    const [openTestEmailPopup, setOpenTestEmailPopup] = useState(false);
    const [openEmailPopup, setOpenEmailPopup] = useState(false);
    const [subject, setSubject] = useState("");
    const [emailAddresses, setEmailAddresses] = useState([]);
    const [recipientType, setRecipientType] = useState("report"); // or "manual"
    const [manualEmails, setManualEmails] = useState([]);
    //editor initialization
    useEffect(() => {
        if (!editorRef.current) return;
        document.head.insertAdjacentHTML('beforeend', `
    <style>
      .gjs-one-bg { background: white !important; }
      .gjs-two-color { color: #333 !important; }
      .gjs-block { background: rgba(255,255,255,0.9) !important; }
      .gjs-pn-panel,.gjs-pn-commands { overflow-x: auto !important;white-space: nowrap !important;}
    </style>
  `);
        const editor = grapesjs.init({
            container: editorRef.current,
            height: "100vh",
            fromElement: false,
            storageManager: false,
            plugins: [presetNewsletter],
            assetManager: {         //for the image upload
                upload: false,
                autoAdd: false,
                uploadFile: async (e) => {
                    const files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
                    const file = files[0];
                    const formData = new FormData();
                    formData.append("file", file);
                    try {
                        const res = await dispatch(
                            postFormData({ apiUrl: "/template/saveImage", formData })
                        ).unwrap();
                        if (res?.success && res?.file) {
                            const imageUrl = res.file;  // Add image to asset manager
                            editor.AssetManager.add({ src: imageUrl });
                            // auto-set to selected component if its image
                            const selected = editor.getSelected();
                            if (selected && selected.is('image')) {
                                selected.set('src', imageUrl);
                            }
                        } else {
                            console.error("Upload failed:", res);
                        }
                    } catch (err) {
                        console.error("Image upload error:", err);
                    }
                }
            }
        });
        // Load the saved draft
        const htmlContent = location.state?.content;
        if (htmlContent) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlContent, "text/html");
            const bodyHtml = doc.body.innerHTML;
            editor.setComponents(bodyHtml);
        }
        editorInstance.current = editor;
        editor.on("load", () => {
            editor.Panels.removeButton('options', 'gjs-open-import-template');
            editor.RichTextEditor.add('color', {
                icon: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M5 21h14v-2H5v2zm7-18C9.13 3 7 5.13 7 8c0 3.75 5 11 5 11s5-7.25 5-11c0-2.87-2.13-5-5-5z"/></svg>',
                title: 'Text Color',
                result: (rte) => {
                    const input = document.createElement('input');
                    input.type = 'color';
                    Object.assign(input.style, {
                        position: 'fixed',
                        left: '50%',
                        top: '50%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 9999
                    });
                    document.body.appendChild(input);
                    input.addEventListener('input', e => rte.exec('foreColor', e.target.value));
                    const cleanup = () => input.remove() || window.removeEventListener('keydown', onEsc);
                    const onEsc = e => e.key === 'Escape' && cleanup();
                    input.addEventListener('blur', cleanup);
                    window.addEventListener('keydown', onEsc);
                    input.click();
                    input.focus();
                }
            });
            editor.DomComponents.getType('text').model.prototype.defaults.toolbar = [
                'undo', 'redo', 'bold', 'italic', 'underline', 'link', 'color'
            ];
            //Customize the button block
            const buttonBlock = editor.BlockManager.get("button");
            if (buttonBlock) {
                buttonBlock.set("content", `
                <table cellpadding="0" cellspacing="0" role="presentation" width="100%">
                    <tr>
                        <td align="center">
                            <a href="#" style="
                                display: inline-block;
                                background-color: #007bff;
                                color: #ffffff;
                                padding: 10px 20px;
                                border-radius: 4px;
                                text-decoration: none;
                                text-align: center;
                                font-weight: bold;
                                font-family: Arial, sans-serif;
                            ">Click Me</a>
                        </td>
                    </tr>
                </table>
            `);
            }
        });
        return () => {
            editor.destroy();
            editorInstance.current = null;
        };
    }, []);

    const handleFreezStop = () => setFreez(false);
    const handleFreezStart = () => setFreez(true);

    const [availableReports, setAvailableReports] = useState([]);
    const [chosenReport, setChosenReport] = useState("");
    const [loadingReports, setLoadingReports] = useState(false);
    const isUsingFetchedRecipients = uploadedFile || selectedReport || (selectedRows && selectedRows.length > 0);
    useEffect(() => {
        if (openEmailPopup && availableReports.length === 0) {
            fetchSavedReports();
        }
    }, [openEmailPopup]);
    const fetchSavedReports = async () => {
        try {
            setLoadingReports(true);
            const res = await dispatch(fetchData("/reports/all")).unwrap();
            if (res?.success) {
                setAvailableReports(res.data.map(item => ({ id: item.id, name: item.report_name, file: item.file })));
            } else {
                swal("Error!", "Something went wrong!", "error");
            }
        } catch (error) {
            swal("Error!", "Failed to fetch saved reports", "error");
        } finally {
            setLoadingReports(false);
        }
    };

    const handleSendTestEmail = async () => {
        const editor = editorInstance.current;
        if (!editor) {
            swal("Error", "Editor not initialized", "error");
            return;
        }
        // to Get HTML from GrapesJS
        const finalHtml = editor.runCommand('gjs-get-inlined-html');
        if (!finalHtml || !finalHtml.replace(/<[^>]*>/g, '').replace(/\s+/g, '').trim()) {
            swal("Email Template Required", "Please create your email template first.", "warning");
            return;
        }
        const inputElement = document.querySelector('input[placeholder="Type or paste emails, press Enter"]');
        const pendingInput = inputElement?.value?.trim() || '';
        let recipients = [...emailAddresses];
        if (pendingInput) {
            const extraEmails = pendingInput
                .split(/[ ,\n]/)
                .map(email => email.trim())
                .filter(Boolean);
            recipients = [...recipients, ...extraEmails];
        }
        recipients = Array.from(new Set(recipients));
        if (!recipients.length) {
            swal("Missing Email", "Enter at least one email.", "warning");
            return;
        }
        if (!subject.trim()) {
            swal("Please enter a subject before sending the email");
            return;
        }
        const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        const invalid = recipients.filter(email => !isValidEmail(email));
        if (invalid.length > 0) {
            swal("Error!", `Invalid email: ${invalid.join(", ")}`, "error");
            return;
        }
        const formData = new FormData();
        formData.append("recipients", JSON.stringify(recipients));
        formData.append("scheduleTime", "now");
        formData.append("testEmail", "True");
        formData.append("file", "");
        formData.append("subject", subject);
        // create HTML structure
        formData.append("content", `
      <!DOCTYPE html>
      <html>
        <head>
          <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
        </head>
        <body style="margin:0; padding:0;">
          ${finalHtml}
        </body>
      </html>
    `);
        try {
            setFreez(true);
            const res = await dispatch(postFormData({
                apiUrl: "/sentEmails/send",
                formData
            })).unwrap();

            if (res?.success) {
                swal("Success!", "Test email sent!", "success");
                setOpenTestEmailPopup(false);
                setEmailAddresses([]);
            } else {
                swal("Error!", res.message || "Something went wrong!", "error");
            }
        } catch (err) {
            console.error(err);
            swal("Error!", err.message || "Failed to send test email", "error");
        } finally {
            setFreez(false);
        }
    };

    const [openSaveDraftPopup, setOpenSaveDraftPopup] = useState(false);
    const [templateName, setTemplateName] = useState("");
    const handleSaveDraft = async () => {
        const editor = editorInstance.current;
        if (!editor) {
            swal("Error", "Editor not initialized", "error");
            return;
        }
        const finalHtml = editor.runCommand('gjs-get-inlined-html');
        if (!finalHtml || !finalHtml.replace(/<[^>]*>/g, '').replace(/\s+/g, '').trim()) {
            swal("Email Template Required", "Please create your email template first.", "warning");
            return;
        }
        if (!subject.trim()) {
            swal("Missing Subject", "Please enter a subject.", "warning");
            return;
        }
        if (!templateName.trim()) {
            swal("Missing Template Name", "Please enter a template name.", "warning");
            return;
        }
        // Get the  HTML from GrapesJS       
        const formData = new FormData();
        formData.append("subject", subject);
        formData.append("template_name", templateName);
        formData.append("content", `
    <!DOCTYPE html>
    <html>
      <head>
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </head>
      <body style="margin:0; padding:0;">
        ${finalHtml}
      </body>
    </html>
  `);
        setFreez(true);
        try {
            const apiUrl = "/template/save";
            const res = await dispatch(postFormData({ apiUrl, formData })).unwrap();
            if (res?.success) {
                swal("Success!", "Draft saved successfully!", "success").then(() => {
                    setOpenSaveDraftPopup(false);
                    setSubject("");
                    setTemplateName("");
                });
            } else {
                const errorMessage =
                    res.message?.message ||
                    res.message?.messageAll?.[0] ||
                    res.message ||
                    res.error?.message ||
                    "Something went wrong!";
                swal("Error!", errorMessage, "error");
            }
        } catch (error) {
            const errorMessage = error?.error?.message || error?.message || "Failed to save draft";
            swal("Error!", errorMessage, "error");
        } finally {
            setFreez(false);
        }
    };
    const [openScheduleSection, setOpenScheduleSection] = useState(false);
    const handleScheduleLaterClick = () => {
        setOpenScheduleSection(true); // Show the date/time 
    };
    const handleCancelClick = () => {
        setOpenScheduleSection(false); // Hide the date/time 
    };
    const pstDate = moment().tz('America/Los_Angeles'); // current PST time
    const [selectedDate, setSelectedDate] = useState(dayjs(pstDate.format('YYYY-MM-DD')));
    const [selectedTime, setSelectedTime] = useState(dayjs(pstDate.format('YYYY-MM-DD HH:mm:ss')));
    const [isSendingNow, setIsSendingNow] = useState(false);
    const [isScheduling, setIsScheduling] = useState(false);
    const handleSendEmail = async (scheduleLater = false) => {
        if (isSendingNow || isScheduling) {
            swal({
                title: "Action in Progress", text: "Please wait for the current action to complete.",
                icon: "info", timer: 2000, buttons: false,
            });
            return;
        } // loading state
        if (scheduleLater) {
            setIsScheduling(true);
        } else {
            setIsSendingNow(true);
        }
        const apiUrl = "/sentEmails/send";
        const token = localStorage.getItem("token");
        if (!token) {
            navigate('/login');
            //  Reset states
            setIsSendingNow(false);
            setIsScheduling(false);
            return;
        }
        const editor = editorInstance.current;
        if (!editor) {
            swal("Error!", "Email editor is not ready.", "error");
            //  Reset states
            setIsSendingNow(false);
            setIsScheduling(false);
            return;
        }
        const finalHtml = editor.runCommand("gjs-get-inlined-html");
        if (!finalHtml || !finalHtml.replace(/<[^>]*>/g, '').replace(/\s+/g, '').trim()) {
            swal("Email Template Required", "Please create your email template first.", "warning");
            //  Reset states
            setIsSendingNow(false);
            setIsScheduling(false);
            return;
        }
        const content = `
    <!DOCTYPE html>
    <html>
    <head>
        <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    </head>
    <body style="margin:0; padding:0;">
        ${finalHtml}
    </body>
    </html>`.trim();
        const formData = new FormData();
        const extractPlaceholders = (text) => {
            const regex = /\*\|([^|]+)\|\*/g;
            const matches = new Set();
            let match;
            while ((match = regex.exec(text)) !== null) {
                matches.add(match[1].trim());
            }
            return Array.from(matches);
        };
        formData.append("contentPlaceholders", JSON.stringify(extractPlaceholders(content)));
        formData.append("content", content);
        let csvFile = uploadedFile;
        let emailArray = [];
        if (recipientType === "manual") {
            //  Get pending email from the input field
            const inputElement = document.querySelector('input[placeholder="Type or paste emails, press Enter"]');
            const pendingInput = inputElement?.value?.trim() || "";
            // Merge manualEmails and pending input
            emailArray = [...manualEmails];
            if (pendingInput) {
                const extraEmails = pendingInput
                    .split(/[ ,\n]/)
                    .map(email => email.trim())
                    .filter(Boolean);
                emailArray = [...emailArray, ...extraEmails];
            }
            // Validate emails
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const validEmails = emailArray.filter(email => emailRegex.test(email));
            const invalidEmails = emailArray.filter(email => !emailRegex.test(email));
            if (validEmails.length === 0) {
                swal("Error!", "Please enter at least one valid email address.", "error");
                // Added: Reset states
                setIsSendingNow(false);
                setIsScheduling(false);
                return;
            }
            if (invalidEmails.length > 0) {
                swal("Error!", `Invalid email(s): ${invalidEmails.join(", ")}`, "error");
                // Added: Reset states
                setIsSendingNow(false);
                setIsScheduling(false);
                return;
            }
            // Create CSV for valid emails
            const generateManualCSV = (emails) => {
                const headers = ["Email"];
                const rows = emails.map(email => [email]);
                return [headers.join(","), ...rows.map(row => row.join(","))].join("\n");
            };
            const manualCSV = generateManualCSV(validEmails);
            const manualCSVBlob = new Blob([manualCSV], { type: "text/csv" });
            csvFile = new File([manualCSVBlob], "manual_recipients.csv", { type: "text/csv" });
        }
        const reportToUse = selectedReport || chosenReport;
        if (!csvFile && reportToUse?.file) {
            try {
                const decodedCSV = atob(reportToUse.file);
                const csvBlob = new Blob([decodedCSV], { type: "text/csv" });
                csvFile = new File([csvBlob], "report.csv", { type: "text/csv" });
            } catch (error) {
                swal("Error!", "Failed to decode report file.", "error");
                // Reset states
                setIsSendingNow(false);
                setIsScheduling(false);
                return;
            }
        }
        if (!csvFile && selectedRows && selectedRows.length > 0) {
            try {
                csvFile = generateCSVFile(selectedRows);
            } catch (error) {
                swal("Error!", "Failed to generate CSV file.", "error");
                setIsSendingNow(false);
                setIsScheduling(false);
                return;
            }
        }
        if (!csvFile) {
            swal("Error!", "No CSV file selected or generated.", "error");
            setIsSendingNow(false);
            setIsScheduling(false);
            return;
        }
        let mergedRecipients = [];
        if (recipientType === "manual") {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const validEmails = emailArray.filter(email => emailRegex.test(email));
            mergedRecipients = validEmails.map(email => ({ email }));
        } else if (csvRows && csvRows.length > 0) {
            mergedRecipients = csvRows;
        } else {
            swal("Error!", "No recipients found to send the email.", "error");
            setIsSendingNow(false);
            setIsScheduling(false);
            return;
        }
        if (!subject || subject.trim() === "") {
            swal("Missing Subject", "Please enter a subject line.", "warning");
            setIsSendingNow(false);
            setIsScheduling(false);
            return;
        }
        formData.append("subject", subject);
        formData.append("subjectPlaceholders", JSON.stringify(extractPlaceholders(subject)));
        const generateFinalCSV = (recipients) => {
            // Use headers from csvColumns or fallback to static headers
            const headers = csvColumns.length > 0
                ? csvColumns.map(col => col.headerName)
                : [
                    "Company Name", "First Name", "Last Name", "Email", 'communication_email',
                    "Phone no.", "address", "city", "state_code", "zip_code",
                    "total_enrollements", "active_enrollements", "totalApprovedCommission", "paidAmount"
                ];
            const rows = recipients.map(r =>
                headers.map(header => {
                    const col = csvColumns.find(c => c.headerName === header); // Find the corresponding field name in csvColumns
                    const field = col ? col.field : header.toLowerCase().replace(/\W+/g, "_");
                    return r[field] || "";
                })
            );            // Convert to CSV format
            return [headers, ...rows].map(row => row.join(",")).join("\n");
        };
        const finalCSV = generateFinalCSV(mergedRecipients);
        const finalCSVBlob = new Blob([finalCSV], { type: "text/csv" });
        const finalCSVFile = new File([finalCSVBlob], "merged_recipients.csv", { type: "text/csv" });
        const generateUniqueFileName = (originalName) => {
            const fileExtension = originalName.split('.').pop();
            return `${Date.now()}_${Math.random().toString(36).substring(7)}.${fileExtension}`;
        };
        const uniqueFileName = generateUniqueFileName(finalCSVFile.name);
        const renamedFile = new File([finalCSVFile], uniqueFileName, { type: finalCSVFile.type });
        formData.append("file", renamedFile);

        if (reportToUse?.id) {
            formData.append("reportId", reportToUse.id);
        }
        let scheduleTime = "now";
        if (scheduleLater) {
            if (!selectedDate || !selectedTime) {
                swal("Error!", "Please select a date and time to schedule the email.", "error");
                setIsSendingNow(false);
                setIsScheduling(false);
                return;
            }
            const combinedDateTime = `${selectedDate.format("YYYY-MM-DD")} ${selectedTime.format("HH:mm:ss")}`;
            const scheduledPST = moment.tz(combinedDateTime, "America/Los_Angeles");
            scheduleTime = scheduledPST.format("YYYY-MM-DDTHH:mm:ss");
        }
        formData.append("scheduleTime", scheduleTime);
        swal({
            title: scheduleLater ? "Confirm Schedule" : "Confirm Send",
            text: scheduleLater
                ? "Do you want to schedule this email?"
                : "Do you want to send this email now?",
            icon: "warning",
            buttons: ["Cancel", "Yes"],
            dangerMode: true,
        }).then(async (willSend) => {
            if (!willSend) {
                setIsSendingNow(false);
                setIsScheduling(false);
                return;
            }
            try {
                const res = await dispatch(postFormData({ apiUrl, formData })).unwrap();
                if (res && res.success === true) {
                    const successMessage = scheduleLater
                        ? "Email scheduled successfully!"
                        : "Email sent successfully!";
                    swal("Success!", successMessage, "success").then(() => {
                        setOpenEmailPopup(false);
                        setSubject("");
                        setChosenReport(null);
                        navigate(location.pathname, { replace: true, state: {} });
                    });
                }
            } catch (error) {
                swal("Error!", "Failed to send email", "error");
            } finally {
                setIsSendingNow(false);
                setIsScheduling(false);
            }
        });
    };

    const validateEmailTemplate = () => {
        const editor = editorInstance.current;
        if (!editor) {
            swal("Error!", "Email editor is not ready.", "error");
            return false;
        }
        const finalHtml = editor.runCommand("gjs-get-inlined-html");
        const plainText = finalHtml?.replace(/<[^>]*>/g, '').replace(/\s+/g, '').trim();
        if (!finalHtml || !plainText) {
            swal("Email Template Required", "Please create your email template first.", "warning");
            return false;
        }
        return true;
    };
    const generateCSVFile = () => {
        if (uploadedFile) {
            console.log("Using uploaded CSV file.");
            return uploadedFile;  // Use the uploaded file directly  
        }
        if (!selectedRows || selectedRows.length === 0) {
            console.log("No data available to generate CSV.");
            return null;
        }
        // Define CSV headers
        const headers = ["Company Name", "First Name", "Last Name", "Email", 'communication_email', "Phone no.", "address", "city", "state_code", "zip_code", "total_enrollements", "active_enrollements", "totalApprovedCommission", "paidAmount"];
        const csvRows = selectedRows.map(row => [
            row.company_name || "",
            row.first_name || "",
            row.last_name || "",
            row.email || "",
            row.communication_email || "",
            row.phone_no || "",
            row.address || "",
            row.city || "",
            row.state_code || "",
            row.zip_code || "",
            row.total_enrollements || "",
            row.active_enrollements || "",
            row.totalApprovedCommission || "",
            row.paidAmount || ""
        ]);
        const csvContent = [headers, ...csvRows].map(row => row.join(",")).join("\n");
        const csvBlob = new Blob([csvContent], { type: "text/csv" });        // Convert CSV 
        const uniqueFileName = `contacts_${Date.now()}.csv`;         // Generate a UNIQUE filename 
        return new File([csvBlob], uniqueFileName, { type: "text/csv" });        //  new File object 
    };
    const [csvRows, setCsvRows] = useState([]);
    const [csvColumns, setCsvColumns] = useState([]);
    const [openConfirm, setOpenConfirm] = useState(false);
    const [confirmMessage, setConfirmMessage] = useState("");
    const [openCSVPopup, setOpenCSVPopup] = useState(false);
    const [confirmAction, setConfirmAction] = useState(() => () => { });
    const openConfirmation = (message, action) => {      //  open the confirmation dialog
        setConfirmMessage(message);
        setConfirmAction(() => action); // Store  function to SHOW on confirm
        setOpenConfirm(true);
    };
    useEffect(() => {
        const processCSV = (csvText) => {
            if (typeof csvText !== "string") {
                console.log("CSV data is not a string:", csvText);
                return;
            }
            const [headerLine, ...lines] = csvText.trim().split("\n");
            if (!headerLine) return;
            const headers = headerLine.split(",").map(h => {
                const sanitizedField = h.trim().replace(/\W+/g, "_").toLowerCase();
                return {
                    field: sanitizedField,
                    headerName: h.trim(),
                    flex: 1,
                    minWidth: 150,
                };
            });
            const rows = lines.map((line, index) => ({
                id: index + 1,
                ...Object.fromEntries(headers.map((h, i) => [h.field, line.split(",")[i] || ""]))
            }));

            setCsvColumns(headers);
            setCsvRows(rows);
        };
        if (uploadedFile) {
            const reader = new FileReader();
            reader.onload = (e) => processCSV(e.target.result);
            reader.readAsText(uploadedFile);
        } else if (chosenReport?.file) {
            try {
                const decoded = atob(chosenReport.file);
                processCSV(decoded);
            } catch (err) {
                console.log("Error decoding chosenReport:", err);
            }
        } else if (selectedReport?.file) {
            try {
                const decoded = atob(selectedReport.file);
                processCSV(decoded);
            } catch (err) {
                console.log("Error decoding selectedReport:", err);
            }
        } else if (selectedRows.length > 0) {
            const csvFile = generateCSVFile();
            if (csvFile) {
                const reader = new FileReader();
                reader.onload = (e) => processCSV(e.target.result);
                reader.readAsText(csvFile);
            }
        } else {
            setCsvRows([]);
            setCsvColumns([]);
        }
    }, [uploadedFile, chosenReport, selectedReport]);
    const handleViewCSV = () => {
        setOpenCSVPopup(true);
    };
    const [openForm, setOpenForm] = useState(false); // Recipient popup
    const [selectedTableRows, setSelectedTableRows] = useState([]);
    useEffect(() => {          // to show the checkbox selected for the table by default
        if (csvRows.length) {
            setSelectedTableRows(csvRows.map((row) => row.id));
        }
    }, [csvRows]);
    const handleSelectionChange = (selection) => {     // TO SELECT THE ROW OF THE TABLE TO DELETE
        setSelectedTableRows(selection);
    };
    const handleDeleteSelected = () => {        //to delete selected csv rows
        setCsvRows(csvRows.filter((row) => !selectedTableRows.includes(row.id)));
        setSelectedTableRows([]); // Clear selection after delete
    };
    // to add new Recipient
    const requiredFields = ["company_name", "first_name", "last_name", "email", "email_address", "e-mail"];
    const filteredColumns = csvColumns.filter(col =>         // Filter  required fields
        requiredFields.includes(col.field.trim().toLowerCase())
    );
    // Initialize values only for required fields
    const initialValues = Object.fromEntries(filteredColumns.map(col => [col.field, ""]));
    const validationSchema = Yup.object().shape(
        Object.fromEntries(filteredColumns.map(col => {
            if (["email", "email_address", "e-mail"].includes(col.field.toLowerCase())) {
                return [col.field, Yup.string()
                    .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, "Invalid email format")
                    .email("Invalid email format")
                    .required("Email is required")
                ];
            }
            if (col.field.toLowerCase() === "company_name") {
                return [col.field, Yup.string()
                    .matches(/^[A-Za-z0-9@ ]*$/, "Company name cannot contain special characters like #, %, *, &, $, !")
                    .required("Company name is required")];
            }
            return [col.field, Yup.string()];
        }))
    );
    const ContentLayout = (
        <>
            <Box container lg={12} md={12} xs={12} sm={12} sx={{
                display: "flex", justifyContent: "space-between", alignItems: "center", mb: 1
            }}>
                <Box item flexGrow={1}>
                    <Typography variant="h6" className="emailTitle"> Create Email</Typography>
                </Box>
                <Box item className="buttonContainer" sx={{ display: "flex", flexWrap: "wrap", justifyContent: "flex-end", gap: 1, marginRight: '12px' }}>
                    <Button className="saveDraft" variant="contained" onClick={() => { if (!validateEmailTemplate()) return; setOpenSaveDraftPopup(true); }}>Save Draft</Button>
                    <Button className="sendEmail" variant="contained" onClick={() => { if (!validateEmailTemplate()) return; setOpenEmailPopup(true); }}>Send Email</Button>
                    <Button className="testEmail" variant="outlined" onClick={() => { if (!validateEmailTemplate()) return; setOpenTestEmailPopup(true); }} >Send Test Email</Button>
                    <Button variant="outlined" className="commonOutlinedBtn" onClick={() => navigate("/saved-templates", { state: { selectedRows, uploadedFile, selectedReport } })}>
                        Saved Template
                    </Button>
                </Box>
            </Box>
            <div ref={editorRef} style={{ height: "calc(100vh - 60px)", border: "1px solid #ccc" }} />
        </>
    );

    return (
        <>
            <DefaultLayout content={ContentLayout} />
            <Dialog open={openTestEmailPopup} onClose={() => setOpenTestEmailPopup(false)} maxWidth="sm" fullWidth>
                <DialogTitle>
                    Send Test Email
                    <IconButton
                        edge="end"
                        color="inherit"
                        aria-label="close"
                        onClick={() => setOpenTestEmailPopup(false)}
                        sx={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                        <TextField
                            label="Subject"
                            size="small"
                            variant="outlined"
                            placeholder="Subject"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                        />
                        <Autocomplete
                            multiple
                            freeSolo
                            options={[]}
                            value={emailAddresses}
                            onChange={(event, newValue) => setEmailAddresses(newValue)}
                            onPaste={(e) => {
                                e.preventDefault();
                                const pastedText = e.clipboardData.getData("text");
                                const newEmails = pastedText
                                    .split(/[ ,\n]/)
                                    .map(email => email.trim())
                                    .filter(Boolean);
                                setEmailAddresses((prev) => [...prev, ...newEmails]);
                            }}
                            renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                    <Chip variant="outlined" label={option} {...getTagProps({ index })} />
                                ))
                            }
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Enter test email addresses"
                                    size="small"
                                    fullWidth
                                    placeholder="Type or paste emails, press Enter"
                                />
                            )}
                        />
                        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                            <Button variant="contained" onClick={handleSendTestEmail}>
                                Send Test Email
                            </Button>
                            <Button variant="outlined" onClick={() => setOpenTestEmailPopup(false)}>
                                Cancel
                            </Button>
                        </Box>
                    </Box>
                </DialogContent>
            </Dialog>
            <Dialog open={openSaveDraftPopup} onClose={() => setOpenSaveDraftPopup(false)} maxWidth="sm" fullWidth>
                <DialogTitle>
                    Save Draft
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={() => setOpenSaveDraftPopup(false)}
                        aria-label="close"
                        sx={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                        <TextField
                            label="Subject"
                            size="small"
                            variant="outlined"
                            placeholder="Enter Subject"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                            fullWidth
                        />
                        <TextField
                            label="Template Name"
                            size="small"
                            variant="outlined"
                            placeholder="Enter Template Name"
                            value={templateName}
                            onChange={(e) => setTemplateName(e.target.value)}
                            fullWidth
                        />
                        <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                            <Button variant="contained" onClick={handleSaveDraft}>
                                Save
                            </Button>
                            <Button variant="outlined" onClick={() => setOpenSaveDraftPopup(false)}>
                                Cancel
                            </Button>
                        </Box>
                    </Box>
                </DialogContent>
            </Dialog>
            <Dialog open={openEmailPopup} onClose={() => setOpenEmailPopup(false)} maxWidth="sm" fullWidth>
                <DialogTitle>
                    Send Email
                    <IconButton
                        edge="end" color="inherit" onClick={() => setOpenEmailPopup(false)} aria-label="close"
                        sx={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
                        <Box>
                            <Typography variant="subtitle1" sx={{ mb: 1 }}> Select Recipients:</Typography>
                            <RadioGroup row value={recipientType}
                                onChange={(e) => {
                                    const selectedType = e.target.value;
                                    setRecipientType(selectedType);
                                    if (selectedType === "manual") {
                                        setChosenReport(null); // Only reset csvRows if no fetched recipients are present
                                        if (!isUsingFetchedRecipients) {
                                            setCsvRows([]);
                                        }
                                    } else if (selectedType === "report") { // Only reset manual emails if no fetched recipients are present
                                        if (!isUsingFetchedRecipients) {
                                            setManualEmails([]);
                                        }
                                    }
                                }}
                            >
                                <FormControlLabel value="report" control={<Radio />} label="Use Existing Report" />
                                <FormControlLabel value="manual" control={<Radio />} label="Enter Emails Manually" />
                            </RadioGroup>
                        </Box>
                        {!isUsingFetchedRecipients && recipientType === "report" && (
                            <Select
                                fullWidth displayEmpty size="small"
                                value={chosenReport?.id || ""}
                                onChange={(e) => {
                                    const selectedId = parseInt(e.target.value);
                                    const selectedReportOBJ = availableReports.find(r => r.id === selectedId);
                                    setChosenReport(selectedReportOBJ);
                                }}
                                renderValue={() => chosenReport?.name || "Select a Report"} >
                                <MenuItem value="" disabled>Select a Report</MenuItem>
                                {loadingReports ? (
                                    <MenuItem disabled>
                                        <CircularProgress size={20} sx={{ mr: 1 }} /> Loading Reports...
                                    </MenuItem>
                                ) : (
                                    availableReports
                                        .filter(report => report?.id && report?.name?.trim())
                                        .map((report) => (
                                            <MenuItem key={report.id} value={report.id}>
                                                {report.name}
                                            </MenuItem>
                                        ))
                                )}
                            </Select>
                        )}
                        {recipientType === "manual" && (
                            <Autocomplete
                                multiple freeSolo options={[]}
                                value={manualEmails}
                                onChange={(event, newValue) => setManualEmails(newValue)}
                                onPaste={(e) => {
                                    e.preventDefault();                                           // Prevent the default paste              
                                    const pastedText = e.clipboardData.getData("text");           // Get the pasted text
                                    const newEmails = pastedText                                  // Split the pasted text by spaces or commas
                                        .split(/[ ,\n]/) // Split by space comma
                                        .map((email) => email.trim()) // Trim spaces around each email
                                        .filter(Boolean); // Remove empty entries                                   
                                    setManualEmails((prevEmails) => [...prevEmails, ...newEmails]);
                                }}
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (<Chip variant="outlined" label={option} {...getTagProps({ index })} />))
                                }
                                renderInput={(params) => (
                                    <TextField {...params} label="Enter email addresses"
                                        placeholder="Type or paste emails, press Enter" size="small" variant="outlined" fullWidth
                                    />
                                )}
                            />
                        )}
                        {recipientType === "report" && (
                            <TextField
                                label="To"
                                size="small" variant="outlined"
                                placeholder="Recipient email id"
                                value={csvRows.length > 0 ? `${csvRows.length} Recipient${csvRows.length > 1 ? "s" : ""} Selected` : ""}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={handleViewCSV}>
                                                <Visibility />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        )}
                        <TextField label="From" size="small" variant="outlined" value="bruce.cornelious@myfreescorenow.com" disabled />
                        <TextField
                            label="Subject" size="small" variant="outlined" placeholder="Subject" value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                        />
                        <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                            <Button
                                variant="contained" className="send-button"
                                onClick={() => handleSendEmail(false)}
                                disabled={isSendingNow}
                                startIcon={isSendingNow ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : null}
                            >
                                Send Now
                            </Button>
                            <Button
                                variant="outlined" className="commonOutlinedBtn"
                                onClick={handleScheduleLaterClick}
                            >
                                Schedule for Later
                            </Button>
                        </Box>
                        {openScheduleSection && (
                            <Box sx={{ mt: 1 }}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="Select Date"
                                        value={selectedDate} disablePast
                                        onChange={(newDate) => setSelectedDate(newDate)}
                                        sx={{ width: "100%", mb: 2 }}
                                    />
                                    <TimePicker
                                        label="Select Time"
                                        value={selectedTime}
                                        onChange={(newTime) => setSelectedTime(newTime)}
                                        sx={{ width: "100%" }}
                                    />
                                </LocalizationProvider>
                                <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
                                    <Button
                                        variant="contained" className="schedule-button"
                                        onClick={() => handleSendEmail(true)}
                                        disabled={isScheduling}
                                        startIcon={isScheduling ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : null}
                                    >
                                        Schedule
                                    </Button>
                                    <Button variant="outlined" className="commonOutlinedBtn" onClick={handleCancelClick}>
                                        Cancel
                                    </Button>
                                </Box>
                            </Box>
                        )}
                    </Box>
                </DialogContent>
            </Dialog>
            <Dialog open={openCSVPopup} onClose={() => setOpenCSVPopup(false)} maxWidth="md" fullWidth>
                <DialogTitle>
                    CSV Data
                    <IconButton
                        edge="end" handleViewCSV
                        color="inherit" aria-label="close"
                        onClick={() => setOpenCSVPopup(false)}
                        sx={{ position: 'absolute', right: 8, top: 8 }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    {csvRows.length ? (
                        <Box sx={{ width: "100%", overflowX: "auto", height: 400 }}>
                            <DataGrid
                                rows={csvRows}
                                columns={csvColumns.map((col) => ({
                                    ...col, editable: ["First Name", "Last Name", "Email", "Phone no."].includes(col.headerName), // EDIT ONLY Column header names
                                }))}
                                pageSizeOptions={[10, 20, 50]}
                                pagination checkboxSelection autoHeight
                                rowSelectionModel={selectedTableRows}  // TO show checkbox selected by default
                                onRowSelectionModelChange={handleSelectionChange}
                                processRowUpdate={(updatedRow, oldRow) => {
                                    setCsvRows((prevRows) =>    // Update state after editing a row
                                        prevRows.map((row) => (row.id === updatedRow.id ? updatedRow : row))
                                    );
                                    return updatedRow;
                                }}
                                onProcessRowUpdateError={(error) => {
                                    console.log("Error updating row:", error);
                                }}
                                slots={{ toolbar: GridToolbar }}
                                slotProps={{
                                    toolbar: { showQuickFilter: true }
                                }}
                                sx={{
                                    "& .MuiDataGrid-columnHeaders": {
                                        backgroundColor: "#2E67BC", color: "#fff", fontWeight: "bold"
                                    }
                                }}
                            />
                        </Box>
                    ) : (
                        <Typography>No CSV data available.</Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained" color="error" disabled={selectedTableRows.length === 0} onClick={() => openConfirmation("Are you sure you want to delete the selected recipients?", handleDeleteSelected)}
                        startIcon={<DeleteIcon />}>
                        Delete Selected
                    </Button>
                    <Button variant="contained" className="send-button" onClick={() => setOpenForm(true)} startIcon={<AddIcon />} disabled={!csvRows || csvRows.length === 0}>
                        Add New Recipient
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={openForm} onClose={() => setOpenForm(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Add New Recipient</DialogTitle>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={(values, { resetForm }) => {
                        setCsvRows([...csvRows, { id: csvRows.length + 1, ...values }]);
                        setOpenForm(false);
                        resetForm();
                        swal("Success!", "Recipient has been added successfully.", "success");
                    }}
                >
                    {({ values, handleChange, handleBlur, errors, touched }) => (
                        <Form>
                            <Box display="grid" gridTemplateColumns={{ xs: "1fr", sm: "repeat(2, 1fr)" }} gap={2} sx={{ mt: 2, p: 2 }}>
                                {filteredColumns.map((item) => (
                                    <TextField
                                        key={item.field}
                                        name={item.field}
                                        size="small" fullWidth
                                        label={item.headerName}
                                        value={values[item.field] || ""}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={touched[item.field] && Boolean(errors[item.field])}
                                        helperText={touched[item.field] && errors[item.field]}
                                    />
                                ))}
                            </Box>
                            <DialogActions>
                                <Button onClick={() => setOpenForm(false)} variant="outlined" className="commonOutlinedBtn">Cancel</Button>
                                <Button type="submit" variant="contained" className="send-button">Add</Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>
            <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)} maxWidth="xs" fullWidth>
                <DialogTitle>Confirmation</DialogTitle>
                <DialogContent>{confirmMessage}</DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenConfirm(false)} color="primary">Cancel</Button>
                    <Button onClick={() => { confirmAction(); setOpenConfirm(false); }} color="error" variant="contained"> Confirm</Button>
                </DialogActions>
            </Dialog>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={freez}
                onClick={handleFreezStop}
            >
                <Freez />
            </Backdrop>
        </>
    );
};

export default EmailEditor;